export default "__VITE_ASSET__CqbBR2iV__"